module.exports = __webpack_public_path__ + "img/empty-cart.01ff80f8.png";